module.exports = __webpack_public_path__ + "img/pexels-min-an-977380.d41e860b.jpg";